/*
 *
 *  * Copyright(c) 2022 General Electric Company. All rights reserved.
 *  *
 *  * The copyright to the computer software herein is the property of
 *  * General Electric Company. The software may be used and/or copied only
 *  * with the written permission of General Electric Company or in accordance
 *  * with the terms and conditions stipulated in the agreement/contract
 *  * under which the software has been supplied.
 *
 */
export class UserWorkListParams {
  worklistId: number = null;
  statsOnTop: number = null;
  viewerPreferences: number = null;

  radiologistList: number[] = null;
  referringPhysician: number[] = null;
  designatedAuthorList: number[] = null;
  patientLocationList: number[] = null;
  initialInterpreterList: number[] = null;
  examPriorityList: number[] = null;

  worklistName: string = null;
  examDateRangeToken: string = null;
  beginExamDateRange: string = null;
  endExamDateRange: string = null;
  verifiedDateRangeToken: string = null;
  verifiedBeginDate: string = null;
  verifiedEndDate: string = null;
  patientBirthBeginDate: string = null;
  patientBirthEndDate: string = null;
  patientName: string = null;
  ideographicName: string = null;
  phoneticName: string = null;
  patientIdentifier: string = null;
  departmentCkey: string = null;
  orderingLocationCkey: string = null;
  orderNumber: string = null;
  accession: string = null;

  modalityList: string[] = null;
  examStatusList: string[] = null;
  filterParamsList: string[] = null;
  procedureDescriptionList: string[] = null;
  orderingLocationList: string[] = null;
  protocolStatusList: string[] = null;
  bodyPartList: string[] = null;
  departmentList: string[] = null;
  examSpecialtyList: string[] = null;
  instituteList: string[] = null;
  reportStatusList: string[] = null;
  equipmentList: string[] = null;
  siteList: string[] = null;
  exceptions: string[] = null;

  orderingLocationDtoList: any[] = null;
  assignedToList: any[] = null;

  excludeZeroImageExams: boolean;
  orderBy: boolean;

  //Start: params for linked work list
  isLinked: boolean;
  filterJson: string = null;
  parentWorkListId: number = null;
  aifindingList: string[] = null;
  //End: params for linked work list
}
